export default __webpack_public_path__ + "static/media/640_portfolio04-nl-web.20385ab8.png";